module.exports = __webpack_public_path__ + "static/mh-task2-7b5c524488a68e048c330763485191ca.jpeg";